import {Package, type PackageData} from "@/types/order-entry/Package";
import {OrderEntryFeature, type OrderEntryFeatureData} from "@/types/order-entry/OrderEntryFeature";

export class StrongoOrderEntry {
    public id: number | null;
    public company_id: number;
    public adr: number;
    public labels: number;
    public loading_day_tomorrow: number;
    public leadtime_enabled: number;
    public cut_off_time_enabled: number;
    public cut_off_time: string | null;
    public detailed_track_trace: number;
    public track_trace_link: number;
    public client_emails: string | null;
    public send_client_emails: number;
    public klg_emails: string | null;
    public send_klg_emails: number;
    public client_delivery_update_emails: string | null;
    public send_client_delivery_update_emails: number;
    public send_recipient_delivery_update_whatsapp: number;
    public send_recipient_delivery_update_sms: number;
    public packages: Package[];
    public orderEntryFeatures: OrderEntryFeature[];

    constructor(data: StrongoOrderEntryData | void) {
        if (data === undefined) {
            this.id = null;
            this.company_id = 0;
            this.adr = 0;
            this.labels = 1;
            this.loading_day_tomorrow = 1;
            this.leadtime_enabled = 1;
            this.cut_off_time_enabled = 1;
            this.cut_off_time = "";
            this.detailed_track_trace = 1;
            this.track_trace_link = 0;
            this.client_emails = null;
            this.send_client_emails = 0;
            this.klg_emails = null;
            this.send_klg_emails = 0;
            this.client_delivery_update_emails = null;
            this.send_client_delivery_update_emails = 0;
            this.send_recipient_delivery_update_whatsapp = 0;
            this.send_recipient_delivery_update_sms = 0;
            this.packages = [];
            this.orderEntryFeatures = [];
        } else {
            this.id = data.id;
            this.company_id = data.company_id;
            this.adr = data.adr;
            this.labels = data.labels;
            this.loading_day_tomorrow = data.loading_day_tomorrow;
            this.leadtime_enabled = data.leadtime_enabled;
            this.cut_off_time_enabled = data.cut_off_time_enabled;
            this.cut_off_time = data.cut_off_time;
            this.detailed_track_trace = data.detailed_track_trace;
            this.track_trace_link = data.track_trace_link;
            this.client_emails = data.client_emails;
            this.send_client_emails = data.send_client_emails;
            this.klg_emails = data.klg_emails;
            this.send_klg_emails = data.send_klg_emails;
            this.client_delivery_update_emails = data.client_delivery_update_emails;
            this.send_client_delivery_update_emails = data.send_client_delivery_update_emails;
            this.send_recipient_delivery_update_whatsapp = data.send_recipient_delivery_update_whatsapp;
            this.send_recipient_delivery_update_sms = data.send_recipient_delivery_update_sms;
            this.packages = [];
            if (data.packages !== undefined) {
                data.packages.forEach(pack => this.packages.push((new Package(pack))));
            }

            this.orderEntryFeatures = [];
            if (data.orderEntryFeatures !== undefined) {
                data.orderEntryFeatures.forEach(orderEntryFeature => this.orderEntryFeatures.push((new OrderEntryFeature(orderEntryFeature))));
            }
        }
    }

    serializeData(without_relations: boolean | Array<string> = false) {
        const serialized_data = {
            id: this.id,
            company_id: this.company_id,
            adr: this.adr,
            labels: this.labels,
            loading_day_tomorrow: this.loading_day_tomorrow,
            leadtime_enabled: this.leadtime_enabled,
            cut_off_time_enabled: this.cut_off_time_enabled,
            cut_off_time: this.cut_off_time,
            detailed_track_trace: this.detailed_track_trace,
            track_trace_link: this.track_trace_link,
            client_emails: this.client_emails,
            send_client_emails: this.send_client_emails,
            klg_emails: this.klg_emails,
            send_klg_emails: this.send_klg_emails,
            client_delivery_update_emails: this.client_delivery_update_emails,
            send_client_delivery_update_emails: this.send_client_delivery_update_emails,
            send_recipient_delivery_update_whatsapp: this.send_recipient_delivery_update_whatsapp,
            send_recipient_delivery_update_sms: this.send_recipient_delivery_update_sms,
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('packages')
            )
        ) {
            serialized_data.packages = [];
            this.packages.forEach(el => {
                if (el instanceof Package && typeof el.serializeData === "function") {
                    serialized_data.packages.push(el.serializeData())
                } else {
                    serialized_data.packages.push(el)
                }
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('orderEntryFeatures')
            )
        ) {
            serialized_data.orderEntryFeatures = [];
            this.orderEntryFeatures.forEach(el => {
                if (el instanceof OrderEntryFeature && typeof el.serializeData === "function") {
                    serialized_data.orderEntryFeatures.push(el.serializeData())
                } else {
                    serialized_data.orderEntryFeatures.push(el)
                }
            })
        }

        return serialized_data;
    }
}

export type StrongoOrderEntryData = {
    id: number | null;
    company_id: number;
    adr: number;
    labels: number;
    loading_day_tomorrow: number;
    leadtime_enabled: number;
    cut_off_time_enabled: number;
    cut_off_time: string | null;
    detailed_track_trace: number;
    track_trace_link: number;
    client_emails: string | null;
    send_client_emails: number;
    klg_emails: string | null;
    send_klg_emails: number;
    client_delivery_update_emails: string | null;
    send_client_delivery_update_emails: number;
    send_recipient_delivery_update_whatsapp: number;
    send_recipient_delivery_update_sms: number;
    packages: PackageData[];
    orderEntryFeatures: OrderEntryFeatureData[];
}
